import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { AppType, ConfigurationService } from '@treasury/core/config';
import { ProductFeatureType } from '@treasury/domain/company/product-features/types';
import { CompanyUserService } from '@treasury/domain/company/user';
import { CompanyUserProductEntitlements } from '@treasury/domain/company/user/entities/entitlements';
import { TmBaseComponent } from '@treasury/presentation';
import { TmToastPosture, TmToastService } from '@treasury/presentation/services/toast';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../limits-and-entitlements/limits-and-entitlements.component';

@customElement('tm-bo-limits-and-entitlements-integrated-services')
export class IntegratedServices extends TmBaseComponent {
    @property()
    public readonly companyId?: number;

    @property()
    public readonly userId?: number;

    @InjectProperty()
    declare private readonly config: ConfigurationService;

    @InjectProperty()
    declare private readonly companyUserService: CompanyUserService;

    @InjectProperty()
    declare private readonly toastService: TmToastService;

    @state()
    private loading = true;

    @state()
    private entitlements?: CompanyUserProductEntitlements;

    private get isBoApp() {
        return this.config.app === AppType.BackOffice;
    }

    public render() {
        if (this.loading) {
            return html`<jha-progress></jha-progress> Loading Integrated Services Permissions...`;
        }
        return html`${this.renderLimitsAndEntitlements()}`;
    }

    protected async firstUpdated() {
        try {
            this.loading = true;
            if (this.isBoApp && !this.companyId) {
                throw new Error('Company ID is required');
            }
            if (!this.userId) {
                throw new Error('User ID is required');
            }
            this.entitlements =
                await this.companyUserService.getCompanyUserProductEntitlementsByType(
                    this.userId,
                    ProductFeatureType.IntegratedServices,
                    this.companyId
                );
        } catch {
            this.toastService.show(
                'Error fetching integrated services',
                TmToastPosture.Danger,
                true
            );
        } finally {
            this.loading = false;
        }
    }

    private renderLimitsAndEntitlements() {
        return html`<tm-company-user-limits-and-entitlements-common
            .companyId=${this.companyId}
            .userId=${this.userId}
            .entitlements=${this.entitlements}
        ></tm-company-user-limits-and-entitlements-common>`;
    }
}
